const ISOdate = () => {
    const d = new Date().toLocaleString( 'sv', { timeZoneName: 'short' } ).split(' ');
    return `${d[0]}_${d[1].replace(/:/g, '-')}`;
}

export default ISOdate;